<template>
  <div class="contentBox">
    <navBox :id="navId" :cid="childrenID" ref="navBox"></navBox>
    <!-- 列表 -->
    <div class="content">
      <myHeader></myHeader>
      <div class="organiza-txt">
        <div class="organiza-title clear">
          <p>题型配置</p>
          <div class="btnBox" >
            <button class="btn btn-add" @click="addShow">添加题型</button>
          </div>
        </div>
        <div class="organiza-list">
          <div class="titleList">
            <p v-for="item in titleList" v-bind:key="item.id">{{item.title}}</p>
          </div>
          <div class="dataList">
            <div class="listItem" v-for="(item,index) in dataList" v-bind:key="(index+1)">
              <p :title="(index+1)">{{(index+1)}}</p>
              <p :title="item.topic_type==1?'单选题':item.topic_type==2?'多选题':item.topic_type==3?'判断题':'案例题'">{{item.topic_type==1?'单选题':item.topic_type==2?'多选题':item.topic_type==3?'判断题':'案例题'}}</p>
              <p :title="item.status==0?'未开启':'开启'">{{item.status==0?'未开启':'开启'}}</p>
              <p :title="item.create_time">{{item.create_time}}</p>
              <p style="color:#457AFF;" @click="editShow(item)" v-if="userData.level==1 || userData.level==2&&userData.authority.indexOf('5-1')>-1">编辑</p>
            </div>
          </div>
          <!-- <div class="block pageBox clear">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page.sync="currentPage1"
              :page-size="100"
              layout="prev, pager, next, jumper"
              :total="1000">
            </el-pagination> 
          </div> -->
        </div>
      </div>
    </div>

    <!-- 编辑 -->
    <div class="msgBox tipsBox editBox" v-if="editType">
      <div class="contv">
        <p class="title">{{editType=='add'?'添加':'编辑'}}</p>
        <form>
          <div class="write-txt">
            <p>题目类型：</p>
            <select v-model="addObj.topic_type" v-if="editType=='add'">
              <option value="">请选择</option>
              <option :value="item.id" v-for="item in topicType" v-bind:key="item.id">{{item.title}}</option>
            </select>
            <input type="text" v-else :value="addObj.topic_type==1?'单选题':addObj.topic_type==2?'多选题':addObj.topic_type==4?'案例题':'判断题'" disabled>
          </div>
          <div class="write-txt">
            <p>状态：</p>
            <select v-model="addObj.status">
              <option value="">请选择</option>
              <option :value="item.id" v-for="item in statusList" v-bind:key="item.id">{{item.title}}</option>
            </select>
          </div>
        </form>
        <div class="btnBox">
          <button class="btn btn-sub" @click="editSub">确定</button>
          <button class="btn btn-close" @click="editHide">取消</button>
        </div>
      </div>
    </div>
  </div>
  
</template>

<script>
import navBox from './../components/comment/nav.vue';
import myHeader from './../components/comment/myHeader.vue';
import { getTopicSetList,saveTopicSet,addTopicSet } from "@/assets/js/api";
export default {
  name: "topic-config",
  data() {
    return {
      navId:'5',
      childrenID:'5-5',
      statusList:[
        {id:1,title:'开启'},
        {id:0,title:'未开启'},
      ],
      titleList:[
        {id:1,title:'序号'},
        {id:2,title:'题型'},
        {id:3,title:'状态'},
        {id:5,title:'创建时间'},
      ],
      dataList:[],
      currentPage1: 2,
      topicType:[
        {id:1,title:'单选题'},
        {id:2,title:'多选题'},
        {id:3,title:'判断题'},
        {id:4,title:'案例题'},
      ],
      editType:'',
      token:"",
      addObj:{
        id:'',
        status:0,
        type:'',
      },
      userData:{
        authority:[],
      },
      showType:false
    };
  },
  components: {
    navBox,
    myHeader
  },
  mounted(){
    this.userData = this.$refs.navBox.userData
    this.token =this.userData.token;
    this.getList();
  },
  methods: {
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.getList();
    },

    getList(){
      var that = this;
      getTopicSetList(this.token).then((res)=>{
        var data = res.data;
        if(data.code == 200){
          that.dataList = data.data;
        } else {
          that.$message(data.msg);
        }
      })
    },

    editShow(e){
      this.addObj = {
        id:e.id,
        status:e.status,
        topic_type:e.topic_type,
      };
      console.log(this.addObj)
      this.editType='edit';
      // saveTopicSet
    },

    editHide(){
      this.addObj = {
        id:'',
        status:0,
        type:'',
      };
      this.editType='';
    },

    editSub(){
      if(this.editType == 'add'){
        this.addSub();
        return false;
      }
      var that = this;
      delete this.addObj.topic_type;
      this.addObj.type = '5-1';
      saveTopicSet(this.addObj,this.token).then((res)=>{
        var data = res.data;
        if(data.code == 200){
          that.$message('修改成功！');
          that.editHide();
          that.getList();
        } else {
          that.$message(data.msg);
        }
      })
    },

    addSub(){
      var that = this;
      var obj = {
        topic_type:this.addObj.topic_type,
        status:this.addObj.status
      }
      addTopicSet(obj,this.token).then((res)=>{
        var data = res.data;
        if(data.code == 200){
          that.$message('成功！');
          that.editHide();
          that.getList();
        } else {
          that.$message(data.msg);
        }
      })
    },

    addShow(){
      this.editType = 'add';
    }

  },
};
</script>
<style scoped>
.dataList .listItem p,
.organiza-list p{
  width: 20%;
}

.organiza-txt{
  height: calc(100% - 120px);
}

</style>



// WEBPACK FOOTER //
// src/admin/config.vue